/* eslint-disable no-template-curly-in-string */
import { string, object, SchemaOf } from 'yup'

import { ForgotPasswordDTO } from '../dto'

export const forgotPasswordSchema: SchemaOf<ForgotPasswordDTO> = object({
  email: string().label('email').email().required(),
})
